import React from 'react';
import propTypes from 'prop-types';
import { useFormik } from 'formik';
import * as yup from 'yup';
import classnames from 'classnames';
import Modal from '../Modal';
import TextArea from '../TextArea';

const validationSchema = yup.object({
  type: yup
    .string()
    .required()
    .oneOf(['overdue', 'not_owner', 'other'])
    .default('overdue'),
  description: yup
    .string()
    .when('type', type => {
      switch (type) {
        case 'other':
          return yup.string().required();
        default:
          return yup.string().nullable();
      }
    })
    .default(''),
});

export default function DwellerPermissionReasonModal({ dweller, handleClose, onSubmit }) {
  const { values, handleChange, handleSubmit, errors, touched } = useFormik({
    onSubmit,
    validationSchema,
    initialValues: validationSchema.default(),
  });
  return (
    <Modal className="bg-light">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Permissão na assembleia</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Fechar" onClick={handleClose}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p>
            Justifique o motivo da permissão de&nbsp;
            <strong>apenas visualizar</strong>
            &nbsp;no condomínio
          </p>
          <form className="form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="type">{`${dweller.name} - ${dweller.unity.name}`}</label>
              <select className="form-control" id="type" name="type" onChange={handleChange} value={values.type}>
                <option value="overdue">Inadimplência</option>
                <option value="not_owner">Não é proprietário</option>
                <option value="other">Outro</option>
              </select>
            </div>
            {values.type === 'other' && (
              <div className="form-group">
                <label htmlFor="description">Descreva o motivo abaixo</label>
                <TextArea
                  value={values.description}
                  onChange={handleChange}
                  name="description"
                  id="description"
                  className={classnames({
                    'is-invalid': errors.description && touched.description,
                  })}
                  rows={3}
                />
              </div>
            )}
            <small className="form-text mb-2 text-muted">O condômino receberá a justificativa por e-mail.</small>
            <button className="btn btn-primary float-right" type="submit">
              Confirmar
            </button>
          </form>
        </div>
      </div>
    </Modal>
  );
}

DwellerPermissionReasonModal.propTypes = {
  dweller: propTypes.object.isRequired,
  handleClose: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
};
